import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TagRequest } from '@meta-press/shared-plugins';
import { SourceMaterialService } from '../source-material-service/source-material.service';
import { NotificationService } from '../notification-service/notification.service';

@Component({
	selector: 'app-add-tag-modal',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './add-tag-modal.component.html',
	styleUrls: ['./add-tag-modal.component.scss'],
})
export class AddTagModalComponent {
	newTag: TagRequest = { Name: '', Description: '' };
	isAddingTag = false;

	constructor(
		public activeModal: NgbActiveModal,
		private sourceMaterialService: SourceMaterialService,
		private notificationService: NotificationService,
	) {}

	/**
	 * Add a new tag to the system
	 */
	addNewTag(): void {
		if (!this.newTag.Name.trim()) {
			this.notificationService.ShowToast(
				'Tagin nimi on pakollinen',
				'warning',
			);
			return;
		}

		// Check if tag already exists
		const existingTag = this.sourceMaterialService.GetTagByName(
			this.newTag.Name.trim(),
		);
		if (existingTag) {
			this.notificationService.ShowToast(
				'Tagi samalla nimellä on jo olemassa',
				'warning',
			);
			return;
		}

		this.isAddingTag = true;
		this.sourceMaterialService
			.AddTag({
				Name: this.newTag.Name.trim(),
				Description: this.newTag.Description.trim(),
			})
			.subscribe({
				next: () => {
					this.isAddingTag = false;
					this.notificationService.ShowToast(
						'Tagi lisätty onnistuneesti',
						'success',
					);

					// Clear the form but keep modal open
					this.newTag = { Name: '', Description: '' };
				},
				error: (error) => {
					this.isAddingTag = false;
					this.notificationService.ShowToast(
						'Tagin lisääminen epäonnistui: ' + error,
						'danger',
					);
				},
			});
	}

	close(): void {
		this.activeModal.dismiss();
	}
}
